import { OrgAdminConstants } from '../../../_constants';

const initialState = { removePaUsersLoading: true, data: '', error: false };

export function removePaUsers(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_REMOVE_PA_USERS:
            return {
                removePaUsersLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_REMOVE_PA_USERS:
            return {
                removePaUsersLoading: false,
                data: action.getOrgUser,
                error: false
            };
        case OrgAdminConstants.REMOVE_PA_USERS_ERROR:
            return {
                removePaUsersLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/PaUsers/removePaUsers.reducer.js